import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//bootstrap added
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
//fonts-awesome added
//style.css added
import './assets/style.css'; // Bu satırı ekleyin

createApp(App).use(store).use(router).mount('#app')
